var _line, _line2, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 19.246,
    y1: 47.245,
    x2: 30.83,
    y2: 47.245
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 25.038,
    y1: 41.453,
    x2: 25.038,
    y2: 53.037
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M42.536,14.167 c0,0,9.294,5.875,3.481,11.688c-2.814,2.815-4.106,3.408-4.106,8.096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M67.385,35.99 c-0.639-1.303-3.088-2.158-6.873-2.158c-2.178,0-4.049,0.261-4.066,0.264c-4.233,0.238-5.635,4.242-5.646,4.283l-0.292,0.899h-16.05 l-0.292-0.899c-0.013-0.041-1.413-4.044-5.647-4.283c-0.018-0.002-1.889-0.264-4.067-0.264c-3.785,0-6.234,0.855-6.873,2.158 c-0.361,0.697-6.946,11.185-6.325,29.69c0.014,0.157,0.38,3.852,3.727,3.852c0.81,0,1.749-0.199,2.793-0.594 c1.631-0.562,8.999-6.715,9.393-7.092s5.523-4.685,8.452-4.685h13.727c2.928,0,8.057,4.308,8.45,4.685s7.763,6.528,9.394,7.092 c1.045,0.395,1.983,0.594,2.793,0.594c3.347,0,3.713-3.693,3.727-3.852C74.331,47.175,67.746,36.688,67.385,35.99z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#037FFF",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    cx: 59.084,
    cy: 41.824,
    r: 0.779
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#037FFF",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    cx: 59.084,
    cy: 51.361,
    r: 0.779
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#037FFF",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    cx: 63.854,
    cy: 46.592,
    r: 0.779
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#037FFF",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    cx: 54.316,
    cy: 46.592,
    r: 0.779
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameDev);
export default __webpack_public_path__ + "static/media/game-dev.20147858b407ad93903c5454f0631b6f.svg";
export { ForwardRef as ReactComponent };